import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { ElementListComponent } from "../../runtimeComponent/ElementListComponent";
import { Editor } from "primereact/editor";


interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}

export class DialogForTableRuleComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

        let subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = subSection.ListOfFormSectionElements.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog key={"DialogForTable_"} header={this.props.isEng ? "Business Rule for " + this.props.ele.ENUTitle : "Business Rule for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.contentString()}
                </Dialog>
            </>
        );
        return html;
    }

    contentString = () => {
        let htmlString = [];

        htmlString.push(
            <div>
                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{width:'25%'}}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence} style={{ marginRight: '22px' }}>This table has the summary row</label>
                    </div>
                    <div style={{ marginLeft: '10px' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={"tbl_" + this.props.ele.Sequence} value={this.props.ele.HasSummaryRow}
                            onChange={(e) => { this.props.ele.HasSummaryRow = e.checked ? 'Y' : 'N'; this.props.callback() }} checked={this.props.ele.HasSummaryRow == 'Y'} />
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{width:'25%'}}>
                        <label htmlFor={"tbl_total_col" + this.props.ele.Sequence} style={{ marginRight: '29px' }}>This table has the total column</label>
                    </div>
                    <div style={{ marginLeft: '10px' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={"tbl_total_col" + this.props.ele.Sequence} value={this.props.ele.HasTotalColumn}
                            onChange={(e) => { this.props.ele.HasTotalColumn = e.checked ? 'Y' : 'N'; this.props.callback() }} checked={this.props.ele.HasTotalColumn == 'Y'} />
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{width:'25%'}}>
                        <label htmlFor={"tbl_summary" + this.props.ele.Sequence} style={{ marginRight: '29px' }}>Summarise from flow</label>
                    </div>
                    <div style={{ marginLeft: '10px' }}>
                        {/* @ts-ignore */}
                        <Checkbox 
                            inputId={"tbl_summary" + this.props.ele.Sequence} 
                            value={this.props.ele.summaryFromFlow}
                            checked={this.props.ele.summaryFromFlow}
                            onChange={(e) => { this.props.ele.summaryFromFlow = e.checked; this.props.callback() }}  
                        />
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{width:'25%'}}>
                        <label htmlFor={"tbl_value_update_field" + this.props.ele.Sequence} style={{ marginRight: '22px' }}>Update Field</label>
                    </div>
                    <div style={{ marginLeft: '10px', width:'60%' }}>
                        <InputText className="ontario-input" id={"tbl_value_update_field" + this.props.ele.Sequence} value={this.props.ele.UpdateField}
                            onChange={(e) => { this.props.ele.UpdateField = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{width:'25%'}}>
                        <label htmlFor={"tbl_value_" + this.props.ele.Sequence} style={{ marginRight: '75px' }}>Field</label>
                    </div>
                    <div style={{ marginLeft: '10px', width:'60%'}}>
                        <InputText className="ontario-input" id={"tbl_value_" + this.props.ele.Sequence} value={this.props.ele.LoadBindName}
                            onChange={(e) => { this.props.ele.LoadBindName = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Question Hint</div>
                    <div style={{ marginLeft: '10px', width: '60%'}}>
                    {/* @ts-ignore */}
                    <Editor   style={{ height: 'auto' }} 
                     value={this.props.isEng ? this.props.ele.Hint : this.props.ele.HintFR} onTextChange={(e) => {
                        if (this.props.isEng)
                            this.props.ele.Hint = e.htmlValue;
                        else
                            this.props.ele.HintFR = e.htmlValue;

                        this.props.callback();
                    }}></Editor></div>
                </div>
            </div>
        );

        if (this.props.ele.subSectionList != null && this.props.ele.subSectionList.length > 0) {
            if (this.props.ele.subSectionList[0].ListOfFormSectionElements.filter(p => p.Editable == 'N').length > 0) {
                htmlString.push(
                    <ElementListComponent
                        activeSubSection={this.props.ele.subSectionList[0]}
                        isEng={this.props.isEng}
                        editable={true}
                        topEntity={{}}
                        usedByDesigner={true}
                        user={null}
                        callback={(e) => {
                            this.props.callback();
                        }}
                    ></ElementListComponent>
                );
            }
        }
        return htmlString;
    }


    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
